import React from 'react';

const SECTIONS = [
  { n: 1, title: 'What We Collect', body: 'Email, username, prediction activity, and session cookies.' },
  { n: 2, title: 'How We Use It', body: 'To run your account, track performance, and award prizes.' },
  { n: 3, title: 'Cookies', body: 'Strictly necessary session cookies only. No advertising or tracking cookies.' },
  { n: 4, title: 'Third Parties', body: 'Railway (hosting), Cloudflare (CDN). No data is sold to third parties.' },
  { n: 5, title: 'Your Rights', body: 'Access, deletion, and correction of your data. Email truth@paydirtnews.com.' },
  { n: 6, title: 'Data Retention', body: 'Account data is kept while your account is active and deleted within 30 days of an account deletion request.' },
  { n: 7, title: 'Contact', body: 'truth@paydirtnews.com' },
  { n: 8, title: 'Governing Law', body: 'Applicable US law, with respect to GDPR rights for EU users.' },
];

export default function PrivacyPage({ setPage }) {
  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '40px 20px 80px', fontFamily: "'DM Sans', sans-serif" }}>
      <button
        onClick={() => setPage('home')}
        style={{
          background: 'none', border: 'none', color: '#00e676',
          fontSize: 12, cursor: 'pointer', fontFamily: 'JetBrains Mono, monospace',
          marginBottom: 32, padding: 0,
        }}
      >
        &larr; Back to PayDirt
      </button>

      <h1 style={{ fontFamily: "'Dela Gothic One', cursive", fontSize: 22, color: '#fff', marginBottom: 8 }}>
        PAYDIRT PRIVACY POLICY
      </h1>
      <p style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 11, color: '#666', marginBottom: 28 }}>
        Last updated: March 18, 2026
      </p>

      {SECTIONS.map(s => (
        <div key={s.n} style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 8 }}>
            <span style={{ color: '#00e676', fontFamily: 'JetBrains Mono, monospace', marginRight: 8 }}>{s.n}.</span>
            {s.title}
          </h2>
          <p style={{ color: '#9ca3af', fontSize: 13, lineHeight: 1.75 }}>{s.body}</p>
        </div>
      ))}
    </div>
  );
}
